import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { Notification } from '@portal-core/notifications/models/notification.model';

@CollectionStateSelectors({
  stateType: NotificationsState
})
@State<NotificationsState>({
  name: NotificationsState.source
})
@Service({ autoProvided: false })
export class NotificationsState extends CollectionStateBase {
  static override source = 'Notifications';
  getSource(): string {
    return NotificationsState.source;
  }
}

@Service()
export class NotificationsDataService extends CollectionDataServiceBase<Notification> {
  protected readonly stateType = NotificationsState;
}
